import store from '@/store'
import { onBeforeUnmount, ref, watch } from '@vue/composition-api'

// Uygulama uyarısı (Swal) drawer'ın dışında açıldığından, uyarıdaki "Tamam" tıklaması
// temporary drawer'ın "dışarı tıklama" kapanmasını tetikler. Uyarı açıkken (ve kapandıktan
// hemen sonra, aynı tıklama bitene kadar) true döner; drawer'a :stateless olarak verilir.
export default function useAlertGuard() {
  const alertGuard = ref(false)
  let timer = null

  const stop = watch(
    () => store.state.appAlert.show,
    show => {
      clearTimeout(timer)
      if (show) {
        alertGuard.value = true
      } else {
        timer = setTimeout(() => {
          alertGuard.value = false
        }, 400)
      }
    },
    { immediate: true },
  )

  onBeforeUnmount(() => {
    clearTimeout(timer)
    stop()
  })

  return { alertGuard }
}
